import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect } from "../../../../Components/Forms/renders";

const ArtikelForm = ({ handleSubmit }) => {
  const statusOptions = {
    actief: "Actief",
    inactief: "Inactief",
    uitverkocht: "Uitverkocht"
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-md-6">
              <h5 className="mb-3">Artikel Informatie</h5>
              <Field 
                name="title" 
                type="input" 
                validate={[required()]} 
                component={renderField} 
                label="Titel" 
              />
              <Field 
                name="artiekelnummer" 
                type="input" 
                component={renderField} 
                label="Artikelnummer" 
              />
            </div>
            
            <div className="col-md-6">
              <h5 className="mb-3">Details</h5>
              <Field 
                name="ampere" 
                type="input" 
                component={renderField} 
                label="Ampere" 
              />
              <Field 
                name="status" 
                component={renderselect} 
                options={statusOptions} 
                label="Status" 
              />
            </div>
          </div>
          
          <div className="pull-left submit mt-4">
            <input 
              type="submit" 
              className="btn btn-next btn-fill btn-success btn-wd btn-mg" 
              name="next" 
              value="Opslaan" 
            />
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(
  reduxForm({
    form: "artikel_form",
  })(ArtikelForm)
);